import { render, staticRenderFns } from "./RatingConfig.vue?vue&type=template&id=29ddbdb9&scoped=true&"
import script from "./RatingConfig.vue?vue&type=script&lang=js&"
export * from "./RatingConfig.vue?vue&type=script&lang=js&"
import style0 from "./RatingConfig.vue?vue&type=style&index=0&id=29ddbdb9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ddbdb9",
  null
  
)

export default component.exports